import type { TextField } from '@/src/cms/domain/models/fields/text-field';

export class TextFieldViewModel {
  format: string;
  processed: string;

  constructor(data: { format: string; processed: string }) {
    this.format = data.format;
    this.processed = data.processed;
  }

  static presenter(field: TextField): TextFieldViewModel {
    return new TextFieldViewModel({
      format: field.format,
      processed: field.processed
    });
  }
}
